import React from 'react'
import BlockToolbar from './BlockToolbar'
import LoadingDefault from '../../Elements/Loading/LoadingDefault'

export default class BlockSumFields extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            block: this.props.block,
            data: null,
            loading: false,
            pager: null,
            blockSettings: this.props.block ? this.props.block.settings : null,
            pageError: false,
        }
    }

    fetchData() {
        let environment = this.props.kedo.env().getEnvironment();
        if (!environment) {
            return;
        }

        if (!this.props.block.id) {
            return;
        }

        let api = this.props.kedo.api();
        let params = { params: {} };

        if (this.props.dossier && this.props.dossier.id) {
            params.params.dossier = this.props.dossier.id;
            params.params.dossier = this.props.dossier.id;
            params.params.linkId = this.props.link;
        }
        this.setState({ loading: true });

        api
            .get(api.getMyPageBlockEndpoint(this.props.block.id) + '/data', params)
            .then(response => {
                this.setState({
                    loading: false,
                    data: response.data.result
                });
            });
    }

    componentDidMount() {
        this.fetchData();
    }

    renderData(data) {
        if (!data) {
            return '';
        }

        return data;
    }

    render() {
        return <div className={!this.props.dashboard ? 'kedo-block' : null}
            style={{
                height: '100%',
                marginBottom: '30px',
                minHeight: '300px',
                minWidth: '300px',
            }}>
            <div className="block-header">
                <BlockToolbar
                    onClose={this.props.onClose}
                    onSuccess={this.props.onSuccess}
                    block={this.props.block}
                    kedo={this.props.kedo}
                    fetchData={() => this.fetchData()}
                />
                {this.props.getBlockHeader
                    ? this.props.getBlockHeader(
                        this.props.block,
                        this.props.dossier
                    )
                    : null}
            </div>
          <div className='d-flex align-items-center justify-content-center h-100'>
              {this.state.loading ? (
                <center>
                    <LoadingDefault />
                </center>
            ) : (
                <center>
                    <h1>
                        {this.renderData(this.state.data)}
                    </h1>
                </center>
            )}
          </div>
        </div>
    }
}